import { useNavigate } from 'react-router-dom';
import { messages } from '@fruitways/shared';
import { Icon, ListRow, SkeletonRows } from '@/components';
import { AppFrame } from '@/app/AppFrame';
import { ProfileMenu } from '@/app/ProfileMenu';
import { InlineError, InlineNote, t, useAdminData } from './dataShared';
import '@/screens/Capture/capture.css';

/** Data tab: the master data an admin maintains. */
export function DataHubScreen() {
  const nav = useNavigate();
  const { harvestWeeks, userFarms, season, loading, loadError } = useAdminData();
  const weeksThisSeason = harvestWeeks?.filter((h) => h.seasonId === season?.id).length ?? 0;
  const users = new Set((userFarms ?? []).map((r) => r.username)).size;
  const farms = new Set((userFarms ?? []).filter((r) => r.puc !== 'ALL').map((r) => r.puc)).size;

  return (
    <AppFrame
      title={t.data.title}
      subtitle={messages.header.masterData}
      action={<ProfileMenu />}
      offlineMessage={messages.banner.offlineData}
    >
      <div className="fw-content">
        <span className="fw-secondary">{t.data.intro}</span>
        <div style={{ display: 'flex', flexDirection: 'column', gap: 'var(--space-2)' }}>
          <span className="fw-label">{t.data.section}</span>
          {loading && !loadError && <SkeletonRows count={1} />}
          {loadError && <InlineError>{loadError}</InlineError>}
          {!loading && (
            <div className="fw-rows">
              <ListRow
                leading={<Icon name="calendar-outline" size={24} color="var(--color-primary)" />}
                title={t.data.harvestWeeks}
                secondary={t.data.harvestWeeksHint}
                status={
                  <span className="fw-secondary fw-tnum" style={{ color: 'var(--text-body)' }}>
                    {t.data.harvestWeekCount(weeksThisSeason, season?.label ?? '')}
                  </span>
                }
                navigates
                onClick={() => nav('/data/harvest-weeks')}
              />
              <ListRow
                leading={<Icon name="person-outline" size={24} color="var(--color-primary)" />}
                title={t.data.userFarms}
                secondary={t.data.userFarmsHint}
                status={
                  <span className="fw-secondary fw-tnum" style={{ color: 'var(--text-body)' }}>
                    {t.data.userFarmCount(users, farms)}
                  </span>
                }
                navigates
                onClick={() => nav('/data/user-farms')}
              />
            </div>
          )}
        </div>
        <InlineNote>{t.data.replaceNote}</InlineNote>
      </div>
    </AppFrame>
  );
}
